/**
 * About Euhomy 2 — Ice Cards
 * PC: 5 visible slots (1 wide + 4 narrow), swiper slide + width transition, hover preview.
 * Mobile: center-focus carousel.
 */
(function () {
  'use strict';

  var ANIM_MS = 680;
  var SCROLL_SYNC_MS = 80;
  var MOBILE_MQ = '(max-width: 768px)';
  var DESKTOP_SLOTS = 5;
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

  function q(root, sel) { return root ? root.querySelector(sel) : null; }
  function qa(root, sel) { return root ? Array.from(root.querySelectorAll(sel)) : []; }

  function isMobileView() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function remPx(n) {
    if (window.AboutEuhomy2 && typeof window.AboutEuhomy2.remPx === 'function') {
      return window.AboutEuhomy2.remPx(n);
    }
    var rem = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--rem'));
    return (Number(n) || 0) * (Number.isFinite(rem) && rem > 0 ? rem : 1);
  }

  function afterLayout(fn) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(fn);
    });
  }

  function initOne(root) {
    var track = q(root, '[data-ae2-ice-track]');
    var shell = q(root, '.ae2-ice__track-shell');
    var cards = qa(root, '[data-ae2-ice-card]');
    var prev = q(root, '[data-ae2-ice-prev]');
    var next = q(root, '[data-ae2-ice-next]');
    if (!track || !cards.length) return function () {};

    var initialIndex = Math.floor((cards.length - 1) / 2);
    var activeIndex = initialIndex;
    var committedIndex = initialIndex;
    var isHovering = false;
    var timer = null;
    var resizeTimer = null;
    var scrollTimer = null;
    var isSyncingScroll = false;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-interval') || '5', 10);
    var hoverEnabled = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!Number.isFinite(interval) || interval < 2) interval = 5;

    function syncLenisPrevent() {
      if (isMobileView()) {
        track.setAttribute('data-lenis-prevent', '');
      } else {
        track.removeAttribute('data-lenis-prevent');
      }
    }

    /** 保证激活项在可见 5 张窗口内，靠右对齐滑动 */
    function getWindowStart(targetIndex) {
      var total = cards.length;
      if (total <= DESKTOP_SLOTS) return 0;

      var start = targetIndex - (DESKTOP_SLOTS - 1);
      if (start < 0) start = 0;
      if (start > total - DESKTOP_SLOTS) start = total - DESKTOP_SLOTS;
      return start;
    }

    var resizeObserver = null;
    var slideSnapTimer = null;
    var windowStart = 0;

    function readCssPx(el, prop, fallback) {
      var raw = getComputedStyle(el).getPropertyValue(prop).trim();
      var val = parseFloat(raw);
      return Number.isFinite(val) ? val : fallback;
    }

    function syncTrackHeight() {
      if (!shell) return;

      var card = cards[activeIndex];
      if (!card) return;

      var h = card.offsetHeight;
      if (h > 0) {
        shell.style.setProperty('--ae2-ice-track-h', h + 'px');
      }
    }

    function syncDesktopWidths() {
      if (!shell || isMobileView()) return;

      var shellW = shell.clientWidth;
      if (shellW <= 0) return;

      var designActive = parseFloat(root.getAttribute('data-active-width')) || 500;
      var designGap = parseFloat(root.getAttribute('data-card-gap')) || 16;
      var gap = remPx(designGap);
      root.style.setProperty('--ae2-ice-gap', gap + 'px');

      var total = cards.length;
      var slots = Math.min(DESKTOP_SLOTS, total);
      var inactiveCount = Math.max(1, slots - 1);
      var gapsTotal = inactiveCount * gap;
      var minNarrow = remPx(72);
      var activeW = remPx(designActive);
      var inactiveW = (shellW - activeW - gapsTotal) / inactiveCount;

      if (!Number.isFinite(inactiveW) || inactiveW < minNarrow) {
        inactiveW = minNarrow;
        activeW = Math.max(minNarrow, shellW - gapsTotal - inactiveCount * inactiveW);
      }

      shell.setAttribute('data-ae2-ice-fill', total <= DESKTOP_SLOTS ? 'true' : 'false');
      shell.style.setProperty('--ae2-ice-card-w-active', activeW + 'px');
      shell.style.setProperty('--ae2-ice-card-w', inactiveW + 'px');
      shell.style.setProperty('--ae2-ice-inactive-count', String(inactiveCount));
    }

    /** 按目标布局计算轨道偏移，避免过渡中 offsetLeft 漂移 */
    function measureTrackX(startIndex, activeIdx) {
      var gap = readCssPx(root, '--ae2-ice-gap', 16);
      var inactiveW = readCssPx(shell, '--ae2-ice-card-w', 180);
      var activeW = readCssPx(shell, '--ae2-ice-card-w-active', 400);
      var x = 0;
      for (var i = 0; i < startIndex; i++) {
        x += (i === activeIdx ? activeW : inactiveW) + gap;
      }
      return x;
    }

    function cancelSlideSnap() {
      if (slideSnapTimer) {
        window.clearTimeout(slideSnapTimer);
        slideSnapTimer = null;
      }
    }

    function applyTrackX(x, animate) {
      if (animate) {
        track.style.transition = 'transform ' + ANIM_MS + 'ms ' + EASE;
      } else {
        track.style.transition = 'none';
      }
      track.style.transform = 'translate3d(' + (-x) + 'px, 0, 0)';
      if (!animate) {
        void track.offsetHeight;
        track.style.transition = '';
      }
    }

    function isTrackWrap(fromIndex, toIndex) {
      var total = cards.length;
      if (total <= DESKTOP_SLOTS) return false;
      return (fromIndex === 0 && toIndex === total - 1) || (fromIndex === total - 1 && toIndex === 0);
    }

    function slideTrackTo(targetIndex, animate) {
      cancelSlideSnap();
      var start = getWindowStart(targetIndex);
      var x = measureTrackX(start, targetIndex);
      windowStart = start;
      applyTrackX(x, animate);
    }

    function setActiveIndex(targetIndex) {
      activeIndex = (targetIndex + cards.length) % cards.length;
      cards.forEach(function (card, ci) {
        var on = ci === activeIndex;
        card.classList.toggle('is-active', on);
        if (on) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      });
    }

    function renderDesktop(targetIndex, opts) {
      var animate = !(opts && opts.instant);
      var nextIndex = (targetIndex + cards.length) % cards.length;
      var prevIndex = activeIndex;
      var prevWindow = windowStart;
      var nextWindow = getWindowStart(nextIndex);
      var wrap = isTrackWrap(prevIndex, nextIndex);
      var windowChanged = prevWindow !== nextWindow;

      syncDesktopWidths();
      setActiveIndex(nextIndex);

      afterLayout(function () {
        syncTrackHeight();
        if (cards.length <= DESKTOP_SLOTS || !windowChanged) {
          slideTrackTo(nextIndex, false);
          return;
        }
        if (wrap) {
          slideTrackTo(nextIndex, false);
          return;
        }
        slideTrackTo(nextIndex, animate);
      });
    }

    function scrollToIndex(i, opts) {
      var targetIndex = (i + cards.length) % cards.length;
      var card = cards[targetIndex];
      if (!card) return;

      setActiveIndex(targetIndex);

      var behavior = opts && opts.instant ? 'auto' : 'smooth';
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var target = card.offsetLeft + card.offsetWidth / 2 - track.clientWidth / 2;
      target = Math.max(0, Math.min(target, maxScroll));

      isSyncingScroll = true;
      try {
        track.scrollTo({ left: target, behavior: behavior });
      } catch (e) {
        track.scrollLeft = target;
      }

      function endSync() {
        if (endSync.done) return;
        endSync.done = true;
        isSyncingScroll = false;
      }
      endSync.done = false;

      if (behavior === 'auto') {
        endSync();
        return;
      }

      if (typeof track.onscrollend !== 'undefined') {
        track.addEventListener('scrollend', endSync, { once: true });
      }
      window.setTimeout(endSync, ANIM_MS + 40);
    }

    function findCenteredIndex() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var closest = 0;
      var minDist = Infinity;

      cards.forEach(function (card, ci) {
        var cardCenter = card.offsetLeft + card.offsetWidth / 2;
        var dist = Math.abs(cardCenter - center);
        if (dist < minDist) {
          minDist = dist;
          closest = ci;
        }
      });

      return closest;
    }

    function commit(targetIndex, opts) {
      committedIndex = (targetIndex + cards.length) % cards.length;
      if (isMobileView()) {
        scrollToIndex(committedIndex, opts);
        afterLayout(syncTrackHeight);
        return;
      }
      renderDesktop(committedIndex, opts);
    }

    function updateNavState() {
      var single = cards.length <= 1;
      if (prev) prev.disabled = single;
      if (next) next.disabled = single;
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (!autoplay || isHovering || cards.length <= 1) return;
      timer = window.setInterval(function () {
        commit(activeIndex + 1, { animate: true });
      }, interval * 1000);
    }

    function onPrev() {
      commit(activeIndex - 1, { animate: true });
      start();
    }

    function onNext() {
      commit(activeIndex + 1, { animate: true });
      start();
    }

    function onCardClick(event, ci) {
      var link = cards[ci] && cards[ci].querySelector('.ae2-ice__card-link');
      if (ci === activeIndex) {
        if (!link) {
          if (event) event.preventDefault();
        }
        return;
      }
      if (event) event.preventDefault();
      commit(ci, { animate: true });
      start();
    }

    function onCardEnter(ci) {
      if (!hoverEnabled || isMobileView()) return;
      isHovering = true;
      stop();
      renderDesktop(ci, { animate: true });
    }

    function onRootLeave() {
      if (!isHovering) return;
      isHovering = false;
      renderDesktop(committedIndex, { animate: true });
      start();
    }

    function onRootEnter() {
      stop();
    }

    function onTrackScroll() {
      if (isSyncingScroll || !isMobileView()) return;

      if (scrollTimer) window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        scrollTimer = null;
        var centered = findCenteredIndex();
        if (centered !== activeIndex) {
          committedIndex = centered;
          setActiveIndex(centered);
          syncTrackHeight();
        }
      }, SCROLL_SYNC_MS);
    }

    function onResize() {
      syncLenisPrevent();
      if (isMobileView()) {
        if (shell) {
          shell.removeAttribute('data-ae2-ice-fill');
          shell.style.removeProperty('--ae2-ice-card-w');
        }
        track.style.transform = '';
        track.style.transition = '';
        afterLayout(function () {
          syncTrackHeight();
          scrollToIndex(activeIndex, { instant: true });
        });
        return;
      }
      syncDesktopWidths();
      renderDesktop(activeIndex, { instant: true });
    }

    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    track.addEventListener('scroll', onTrackScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });

    cards.forEach(function (card, ci) {
      card.addEventListener('mouseenter', function () {
        onCardEnter(ci);
      });
      card.addEventListener('click', function (event) {
        onCardClick(event, ci);
      });
    });

    qa(root, '.ae2-ice__media img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', syncTrackHeight, { once: true });
    });

    root.addEventListener('mouseenter', onRootEnter, { passive: true });
    root.addEventListener('mouseleave', onRootLeave, { passive: true });
    root.addEventListener('focusin', onRootEnter);
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) onRootLeave();
    });

    updateNavState();
    syncLenisPrevent();
    committedIndex = initialIndex;
    setActiveIndex(initialIndex);

    if (typeof ResizeObserver !== 'undefined' && shell) {
      resizeObserver = new ResizeObserver(function () {
        if (resizeTimer) window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          resizeTimer = null;
          if (isMobileView()) {
            syncTrackHeight();
            return;
          }
          syncDesktopWidths();
          slideTrackTo(activeIndex, false);
          syncTrackHeight();
        }, 16);
      });
      resizeObserver.observe(shell);
    }

    afterLayout(function () {
      syncDesktopWidths();
      if (isMobileView()) {
        scrollToIndex(initialIndex, { instant: true });
        syncTrackHeight();
      } else {
        renderDesktop(initialIndex, { instant: true });
      }
    });
    start();

    return function () {
      stop();
      cancelSlideSnap();
      if (resizeTimer) window.clearTimeout(resizeTimer);
      if (scrollTimer) window.clearTimeout(scrollTimer);
      if (resizeObserver) resizeObserver.disconnect();
      track.style.transform = '';
      track.style.transition = '';
      track.removeAttribute('data-lenis-prevent');
      if (shell) {
        shell.removeAttribute('data-ae2-ice-fill');
        shell.style.removeProperty('--ae2-ice-card-w');
        shell.style.removeProperty('--ae2-ice-card-w-active');
        shell.style.removeProperty('--ae2-ice-track-h');
      }
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      track.removeEventListener('scroll', onTrackScroll);
      window.removeEventListener('resize', onResize);
      root.removeEventListener('mouseenter', onRootEnter);
      root.removeEventListener('mouseleave', onRootLeave);
    };
  }

  function init() {
    var roots = qa(document, '[data-ae2-ice]');
    var cleanups = roots.map(initOne);
    return function () { cleanups.forEach(function (fn) { fn && fn(); }); };
  }

  if (window.AboutEuhomy2 && typeof window.AboutEuhomy2.register === 'function') {
    window.AboutEuhomy2.register(function () {
      return init();
    });
  } else {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }
})();
